import { linkTo } from "../api/links";
import type { Ack } from "../api/types";
import { Empty, Guid, SEQ, Time } from "./primitives";

type Column = "device" | "driver" | "load";

export function AckTable({
  acks,
  omit = [],
  empty,
}: {
  acks: Ack[];
  omit?: Column[];
  empty: React.ReactNode;
}) {
  if (acks.length === 0) return <Empty>{empty}</Empty>;

  const template = [
    !omit.includes("device") && "minmax(300px,auto)",
    !omit.includes("driver") && "minmax(300px,auto)",
    !omit.includes("load") && "minmax(300px,auto)",
    "110px",
    "minmax(300px,auto)",
    "minmax(110px,1fr)",
  ]
    .filter(Boolean)
    .join(" ");
  const grid = "grid items-center gap-x-4 px-4 py-2";

  return (
    <div className="overflow-x-auto">
      <div
        className={`min-w-max border-b border-line ${grid}`}
        style={{ gridTemplateColumns: template }}
      >
        {!omit.includes("device") && <span className="label">device</span>}
        {!omit.includes("driver") && <span className="label">driver</span>}
        {!omit.includes("load") && <span className="label">load</span>}
        <span className="label" title={SEQ.appliedTo}>
          cursor applied
        </span>
        <span className="label">last applied batch</span>
        <span className="label text-right">applied</span>
      </div>
      {acks.map((ack) => (
        <div
          key={ack.id}
          className={`row-hover min-w-max border-b border-line/70 last:border-b-0 ${grid}`}
          style={{ gridTemplateColumns: template }}
        >
          {!omit.includes("device") && (
            <Guid value={ack.device_guid} to={linkTo.device(ack.device_guid)} />
          )}
          {!omit.includes("driver") && (
            <Guid value={ack.driver_guid} to={linkTo.driver(ack.driver_guid)} />
          )}
          {!omit.includes("load") && (
            <Guid value={ack.root_guid} to={linkTo.root(ack.root_type, ack.root_guid)} />
          )}
          <span className="mono text-xs text-body" title={SEQ.appliedTo}>
            {ack.applied_seq}
          </span>
          <Guid
            value={ack.last_applied_batch_guid}
            to={linkTo.batch(ack.last_applied_batch_guid)}
          />
          <span className="text-right">
            <Time value={ack.applied_at} />
          </span>
        </div>
      ))}
    </div>
  );
}
